<div *ngIf="loading">
    <loading [full]="true"></loading>
</div>
<div *ngIf="!loading" [class.monitor]="isFrontPage">
    <div id="modal-container"></div>
    <ng-container *ngIf="!isHidden">
        <div *ngIf="divContents && divContents['banner']" class="uk-tile uk-tile-default uk-padding uk-border-bottom">
            <helper [texts]="divContents['banner']"></helper>
        </div>
        <navbar *ngIf="hasHeader && !isEmbeddedPage" #navbar portal="monitor_dashboard" [header]="menuHeader" [userMenuItems]=userMenuItems
                [menuItems]="menuItems" [user]="user"
                [notificationConfiguration]="isMobile && user && notificationGroupsInitialized?notificationConfiguration:null">
        </navbar>
        <div *ngIf="isChild" class="uk-banner uk-padding uk-padding-remove-horizontal uk-light">
            <div class="uk-container uk-container-large">
                <div class="uk-padding-small uk-padding-remove-vertical">
                    <div class="uk-grid uk-grid-large uk-flex-middle uk-margin-medium-bottom" uk-grid>
                        <div class="uk-width-expand">
                            <div class="uk-grid uk-grid-small uk-flex-middle" uk-grid>
                                <div class="uk-card uk-card-default uk-padding-small">
                                    <img *ngIf="stakeholder.logoUrl; else elseBlock" [src]="stakeholder | logoUrl"
                                         [alt]="stakeholder.name + ' logo'" class="uk-height-max-xsmall"
                                         style="height: 65px; max-width: 180px;">
                                    <ng-template #elseBlock>
                                        <img src="assets/common-assets/placeholder.png" alt="OpenAIRE placeholder logo"
                                             class="uk-height-max-xsmall" style="height: 65px; max-width: 180px;">
                                    </ng-template>
                                </div>
                                <div class="uk-width-expand uk-margin-small-left">
                                    <h1 class="uk-h5 uk-margin-remove uk-text-truncate">{{ stakeholder.name }}</h1>
                                    <div class="uk-text-small uk-margin-small-top">
                                        <breadcrumbs [breadcrumbs]="breadcrumbs"></breadcrumbs>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="stakeholder.otherParents?.length" class="uk-width-auto">
                            <div class="uk-text-small uk-margin-small-bottom">
                                Other related {{ stakeholderUtils.entities.stakeholders.toLowerCase() }}
                            </div>
                            <div class="uk-flex uk-flex-middle">
                                <a *ngFor="let item of stakeholder.otherParents" [routerLink]="item.alias"
                                   class="uk-link-reset uk-margin-small-right">
                                    <button class="uk-icon-button uk-button-default" [attr.uk-tooltip]="item.name">
                                        <img *ngIf="item.logoUrl; else elseBlock" [src]="item | logoUrl"
                                             [alt]="item.name + ' logo'" style="max-width: 35px;">
                                        <ng-template #elseBlock>
                                            <img src="assets/common-assets/placeholder.png"
                                                 alt="OpenAIRE placeholder logo" style="max-width: 35px;">
                                        </ng-template>
                                    </button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="uk-banner-footer uk-padding-remove">
                <div class="uk-container uk-container-large uk-flex uk-flex-between">
                    <ul class="uk-banner-tab">
                        <li [class.uk-active]="!isSearch">
                            <a [routerLink]="[stakeholder.parent.alias, 'browse', stakeholder.type, stakeholder.alias]">
                                {{ stakeholderUtils.entities.stakeholder }}
                            </a>
                        </li>
                        <li [class.uk-active]="isSearch">
                            <a [routerLink]="properties.searchLinkToResults">
                                Browse {{ openaireEntities.RESULTS }}
                            </a>
                        </li>
                    </ul>
                    <div *ngIf="!isMobile" class="uk-margin-large-right uk-flex uk-flex-middle">
                        <a *ngIf="isManager" [routerLink]="'admin/' + stakeholder.alias" target="_blank"
                           class="uk-button uk-flex uk-flex-middle uk-margin-small-right">
                            Manage
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="isUmbrella" class="uk-banner uk-padding-remove">
            <ul class="uk-banner-tab uk-flex-center">
                <li [class.uk-active]="!isBrowse">
                    <a [routerLink]="stakeholder.alias">
                        {{ stakeholderUtils.entities.stakeholder }}
                    </a>
                </li>
                <li *ngFor="let type of stakeholder.umbrella.types" [class.uk-active]="isBrowse && activeType === type"
                    [class.uk-hidden]="stakeholder.umbrella.children[type].length === 0">
                    <a [routerLink]="stakeholder.alias + '/browse/' + type">
                        Browse {{ stakeholderUtils.entities[type + 's'] }}
                    </a>
                </li>
            </ul>
        </div>
        <div>
            <div class="sidebar_main_swipe uk-flex uk-background-default"
                 [class.sidebar_main_active]="open && (hasSidebar || hasAdminMenu || hasInternalSidebar)"
                 [class.sidebar_mini]="!open &&  (hasSidebar || hasAdminMenu || hasInternalSidebar)"
                 [class.sidebar_hover]="hover">
                <dashboard-sidebar *ngIf="stakeholder && isFrontPage && hasSidebar && !hasInternalSidebar"
                                   queryParamsHandling="merge" [items]="sideBarItems"
                                   [activeItem]="activeTopic?activeTopic.alias:null"
                                   [activeSubItem]="activeCategory?activeCategory.alias:null"></dashboard-sidebar>
                <dashboard-sidebar *ngIf="hasAdminMenu && !hasInternalSidebar" [items]="adminMenuItems"
                                   [backItem]="backItem"></dashboard-sidebar>
                <main class="uk-width-1-1">
                    <router-outlet></router-outlet>
                </main>
            </div>
            <help-pop-up *ngIf="isFrontPage && !isEmbeddedPage && !isBottomIntersecting" [terminology]="monitorLink + '/methodology/terminology'">
                <a class="uk-link-reset" [href]="monitorLink + '/support'" >
                    <div class="uk-flex uk-flex-top">
                        <icon name="description" flex="true" customClass="uk-text-primary"></icon>
                        <div class="uk-margin-small-left">
                            <p class="uk-text-bold uk-margin-xsmall-bottom">Give us your feedback</p>
                            <span class="uk-text-small uk-text-meta">Give general feedback of OpenAIRE Monitor.</span>
                        </div>
                    </div>
                </a>
            </help-pop-up>
            <bottom id="bottom" *ngIf="isFrontPage && !isEmbeddedPage" [centered]="true" [properties]="properties"
                    [showMenuItems]="true"></bottom>
            <cookie-law *ngIf="!isEmbeddedPage" position="bottom">
                OpenAIRE uses cookies in order to function properly.<br>
                Cookies are small pieces of data that websites store in your browser to allow us to give you the best browsing
                experience possible.
                By using the OpenAIRE portal you accept our use of cookies. <a
                    href="https://www.openaire.eu/privacy-policy#cookies" target="_blank"> Read more <span class="uk-icon">
                <svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" icon="chevron-right"
                     ratio="1"><polyline fill="none" stroke="#000" stroke-width="1.03"
                                         points="7 4 13 10 7 16"></polyline></svg>
            </span></a>
            </cookie-law>
            <notification-sidebar *ngIf="!isMobile && user && notificationGroupsInitialized && !isEmbeddedPage"
                                  [configuration]="notificationConfiguration" [user]="user"></notification-sidebar>
            <cache-indicators *ngIf="stakeholder && !isFrontPage && isCurator()"
                              [alias]="stakeholder.alias"></cache-indicators>
            <div *ngIf="view" class="preview uk-text-small uk-flex uk-flex-middle">
                <span>You are currently in a <span class="uk-text-bold">"Preview"</span> mode. <span
                        class="uk-visible@m"><a (click)="removeView()">The current view</a> of this dashboard may differ.</span></span>
            </div>
        </div>
    </ng-container>
    <div *ngIf="projectUpdate && !isFrontPage" class="project-update">
        <div *ngIf="projectUpdate === 'danger'" class="uk-alert uk-alert-danger" uk-alert>
            <a class="uk-alert-close" uk-close></a>
            <div class="uk-text-bold uk-text-small">Projects Status: Urgent Update Needed</div>
            <div class="uk-margin-xsmall-top uk-text-xsmall">
                Your project list was last updated more than a year ago. Please send an updated project list to
                <a href="mailto:mining@openaire.eu">mining&#64;openaire.eu</a> or contact <a
                    [href]="monitorLink + '/contact-us'">support</a>.
            </div>
        </div>
        <div *ngIf="projectUpdate === 'warning'" class="uk-alert uk-alert-warning" uk-alert>
            <a class="uk-alert-close" uk-close></a>
            <div class="uk-text-bold uk-text-small">Projects Status: Update Needed</div>
            <div class="uk-margin-xsmall-top uk-text-xsmall">
                Your project list was last updated between 6 to 12 months ago. Please send an updated project list to
                <a href="mailto:mining@openaire.eu">mining&#64;openaire.eu</a> or contact <a
                    [href]="monitorLink + '/contact-us'" target="_blank" class="custom-external">support</a>.
            </div>
        </div>
    </div>
    <div *ngIf="isHidden" class="private-data uk-light dark">
        <div class="uk-section uk-section-small uk-container uk-container-small uk-text-center">
            <img src="assets/common-assets/logo-services/monitor/inverted.svg" style="height: 80px;">
            <h1 class="uk-h4 uk-margin-large-top">Private Content</h1>
            <div class="uk-text-large">
                The contents of this dashboard are only visible to invited members.
            </div>
            <div class="uk-margin-large-top uk-margin-large-bottom">
                <icon name="incognito" ratio="7"></icon>
            </div>
            <div class="uk-margin-medium-bottom">
                <div *ngIf="!user">
                    If you are a member of this dashboard, please sign in.
                </div>
                <div>
                    If you want to be a member of this dashboard - Contact us.
                </div>
            </div>
            <div class="uk-flex uk-flex-center uk-flex-middle">
                <a *ngIf="!user" class="uk-button uk-button-primary uk-margin-right" (click)="login()">Sign in</a>
                <a class="uk-button uk-button-secondary" [href]="monitorLink + '/contact-us'">Contact us</a>
            </div>
        </div>
    </div>
    <role-verification *ngIf="stakeholder" [id]="stakeholder.alias" [name]="stakeholder.name"
                       [dashboard]="'OpenAIRE Monitor'"
                       [type]="stakeholder.type" [userInfoLink]="monitorLink + '/user-info'"></role-verification>
</div>
